import { Box, Typography, useTheme } from "@mui/material";

export default function ListPageHeader({ icon, title, count, children }) {
  const theme = useTheme();
  const accent = theme.palette.secondary.main;
  const textPri = theme.palette.neutral.dark;
  const textSec = theme.palette.neutral.main;

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Box sx={{
          width: "40px", height: "40px", borderRadius: "10px",
          backgroundColor: "rgba(29,158,117,0.12)",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: accent, flexShrink: 0,
        }}>
          {icon}
        </Box>
        <Box>
          <Typography sx={{ fontFamily: "'DM Serif Display', serif", fontSize: "22px", fontWeight: 400, color: textPri, lineHeight: 1.2 }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: "12px", color: textSec, mt: "2px" }}>
            {count} total records
          </Typography>
        </Box>
      </Box>
      {children}
    </Box>
  );
}
